import React from 'react';
import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import SlackIcon from './Icons/SlackIcon';
import { InnerViewProps } from './types';

const HelpAttachmentContact: React.FC<InnerViewProps> = ({
  setCurrentView,
  goBack,
  appData,
}) => {
  return (
    <>
      <div className="bg-gradient-to-b from-green-500 to-green-600 p-3 py-5 flex justify-between items-center">
        <div
          onClick={goBack}
          className="cursor-pointer hover:bg-green-700 p-2 rounded"
        >
          <AiOutlineArrowLeft />{' '}
        </div>
        <div className="font-medium text-lg">Contact</div>
        <div className="w-6"></div>
      </div>
      <div className="p-4 text-black">
        <h4 className="font-medium text-xl mt-3 w-5/6 mb-10">
          Choose a category below to get in touch with a member of our support
          team
        </h4>

        <div
          role="button"
          tabIndex={0}
          className="shadow bg-white rounded-md p-4 flex items-center justify-between mt-6 cursor-pointer hover:bg-opacity-75 h-32"
          onClick={() => setCurrentView('help_support')}
        >
          <div>
            <span className="font-medium text-md block">
              Help &amp; Support
            </span>
            <p className="font-light text-xs w-5/6">
              We're here to help with any technical &amp; bug related issues
            </p>
          </div>
          <div className="text-green-600">
            <AiOutlineArrowRight size={20} />
          </div>
        </div>

        <a
          className="shadow bg-white rounded-md px-4 flex items-center justify-between mt-6 cursor-pointer hover:bg-opacity-75 h-32"
          href="https://join.slack.com/t/docbloc/shared_invite/zt-p8u7c3xv-M8BogSXRs329P8lUXhWB8g"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div>
            <span className="font-medium text-md block">
              {appData.appName} Community
            </span>
            <p className="font-light text-xs w-5/6">
              Join our public slack channel to discuss with us directly about
              any issues, feature requests or just for a chat
            </p>
          </div>
          <div className="">
            <SlackIcon className="block w-16 h-16" />
          </div>
        </a>
      </div>
    </>
  );
};

export default HelpAttachmentContact;
